// src/utilidades/camposNumericos.js
// Campos numéricos (precios, cantidades, stock) en toda la app, en un solo lugar:
// - La rueda del mouse no cambia el valor: con el campo enfocado, girarla subía
//   o bajaba un precio sin querer. Al girar se quita el foco y la página se
//   desplaza normalmente.
// - Solo se escriben números: el navegador admite «e» y «+» (notación
//   científica) y «-» aunque el campo no acepte negativos.

const esCampoNumerico = (el) => el instanceof HTMLInputElement && el.type === 'number';
// «-» solo donde se aceptan negativos (sin mínimo, o mínimo menor que 0).
const admiteNegativos = (el) => el.min === '' || Number(el.min) < 0;

export const protegerCamposNumericos = (doc = document) => {
  const alGirar = (evento) => {
    const el = evento.target;
    if (esCampoNumerico(el) && el === doc.activeElement) el.blur();
  };
  const alTeclear = (evento) => {
    const el = evento.target;
    if (!esCampoNumerico(el) || evento.ctrlKey || evento.metaKey || evento.altKey) return;
    if (evento.key === 'e' || evento.key === 'E' || evento.key === '+' || (evento.key === '-' && !admiteNegativos(el))) {
      evento.preventDefault();
    }
  };
  doc.addEventListener('wheel', alGirar, { capture: true, passive: true });
  doc.addEventListener('keydown', alTeclear, true);
  return () => {
    doc.removeEventListener('wheel', alGirar, { capture: true });
    doc.removeEventListener('keydown', alTeclear, true);
  };
};
